/**
 * Converts an integer number representing "hundredths of a dollar" into the en-US representation
 * used for dollars, such as: 123456 => 1,234.56
 */
import { LedgerAccount } from '../types';
import { areBalancesReversed } from './ledgerDisplay';

const numberFormatter = new Intl.NumberFormat('en-US', {
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
});
export const formattedCentsAmount = (amountInCents: number): string => {
  return numberFormatter.format(amountInCents / 100);
};

export const formatDollarAmount = (amountInDollars: number): string => {
  return numberFormatter.format(amountInDollars);
};

export const formatAmountForDisplay = (
  ledgerAccount: LedgerAccount,
  amount?: number | string,
): string => {
  if (amount === undefined) return '—';
  if (areBalancesReversed(ledgerAccount)) return formattedCentsAmount(Number(amount) * -1);
  return formattedCentsAmount(Number(amount));
};
